import { Mail, Phone, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

interface ContactUsModalProps {
    open: boolean;
    onClose: () => void;
}

const ContactUsModal = ({ open, onClose }: ContactUsModalProps) => {
    return (
        <AnimatePresence>
            {open && (
                <>
                    {/* Backdrop */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="fixed inset-0 bg-black/40 z-50 backdrop-blur-sm"
                    />

                    {/* Sheet */}
                    <motion.div
                        initial={{ opacity: 0, y: 40, scale: 0.97 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 40, scale: 0.97 }}
                        transition={{ type: "spring", stiffness: 300, damping: 28 }}
                        className="fixed bottom-0 left-0 right-0 z-50 bg-card rounded-t-3xl shadow-2xl p-6 pb-10 md:max-w-md md:mx-auto md:bottom-auto md:top-1/2 md:-translate-y-1/2 md:rounded-3xl"
                    >
                        {/* Close button */}
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 p-1.5 rounded-full hover:bg-muted transition-colors"
                            aria-label="Close" title="Close"
                        >
                            <X className="w-4 h-4 text-muted-foreground" />
                        </button>

                        <h2 className="text-xl font-bold text-foreground mb-5">Contact Us</h2>

                        <div className="space-y-3">
                            {/* Email */}
                            <a
                                href="mailto:freshomeatapp@gmail.com"
                                className="flex items-center gap-4 p-4 bg-muted/50 rounded-2xl hover:bg-muted transition-colors group"
                            >
                                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                                    <Mail className="w-5 h-5 text-primary" />
                                </div>
                                <div>
                                    <p className="text-xs text-muted-foreground font-medium">Email</p>
                                    <p className="text-sm font-semibold text-foreground">freshomeatapp@gmail.com</p>
                                </div>
                            </a>

                            {/* Phone */}
                            <a
                                href="tel:+919537268055"
                                className="flex items-center gap-4 p-4 bg-muted/50 rounded-2xl hover:bg-muted transition-colors group"
                            >
                                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                                    <Phone className="w-5 h-5 text-primary" />
                                </div>
                                <div>
                                    <p className="text-xs text-muted-foreground font-medium">Phone</p>
                                    <p className="text-sm font-semibold text-foreground">+919537268055</p>
                                </div>
                            </a>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default ContactUsModal;
